import React, { useContext, useEffect, useState } from "react";
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates';
import useHttp from '../../../hook/use-http';
import * as $ from 'jquery';
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import 'moment/locale/en-gb';
import "./aisCustom.css";
import { differenceInDays } from 'date-fns'


import DashboardMain from "../DashboardMain/DashboardMain";

import Select from "react-select";
import dataJson from './dataJson.json';
import ChartSecond from "./ChartSecond";
import ChartFirst from "./ChartFirst";


export default function Ais() {
  const [country, setCountry] = useState(null);
  const [langList, setLangList] = useState([]);

  const { isLoading, error, sendReq: fetchData } = useHttp();

  const [firstOption, setFirstOption] = useState("")

  const [startDate, setStartDate] = useState(moment().subtract(8, "days").startOf('day')._d)
  const [startDate1, setStartDate1] = useState(moment().subtract(200, "days").startOf('day')._d)
  const [endDate, setEndDate] = useState(moment().subtract(1, "days").endOf('day')._d)
  const [endDate1, setEndDate1] = useState(moment().subtract(1, "days").endOf('day')._d)
  const [vinNumber, setVinNumber] = useState("")

  const vinNumChanged = (e) => {
    setVinNumber(e.target.value);
  }

  useEffect(() => {
    $("#filterSearch").toggle("slow");
    fetchData({
      url: API_URL_MAIN + "auth/logging", body: {
        page_name: "AIS"
      }
    })
  }, [])

  // code copied from cgarging page 
  const filterHideShow = () => {
    $("#filterSearch").toggle("slow");
  }

  const [type, setType] = useState("tml_cv_ev_stg_staging_can")
  const [filterObject, setFilterObject] = useState({ "start_date": startDate, "end_date": endDate, "vin_no": "", "type": type })
  const [emptyMultiVinError, setEmptyMultiVinError] = useState("")
  const [emptyTypeError, setEmptyTypeError] = useState("")
  const [daysGreterSeven, setdaysGreterSeven] = useState("")
  const filterChanged = (e) => {
    e.preventDefault();
    if (vinNumber.trim() === "") {
      setEmptyMultiVinError("Please enter a Vin Number")
    } else if (vinNumber.split(",").length > 1) {
      setEmptyMultiVinError("Please enter a single Vin Number");
    } else if (country === null) {
      setEmptyTypeError("Please select type")
    } else {
      const diff = differenceInDays(endDate, startDate);
      if (diff < 7) {
        setLangList(changedTypeObj.languages);
        setEmptyTypeError("")
        setdaysGreterSeven("")
        setEmptyMultiVinError("");
        setFilterObject({ "start_date": startDate, "end_date": endDate, "vin_no": vinNumber, "type": type })
      } else {
        setdaysGreterSeven("Select 7 days Range")
      }
    }
  }

  const [changedTypeObj, setChangedTypeObj] = useState({})
  const [dynamicInterval, setdynamicInterval] = useState("")
  const handleCountryChange = (obj) => {
    if (obj.country_code === "ACE") {
      setType("tml_cv_ev_stg_staging_can");
      setStartDate(moment().subtract(8, "days").startOf('day')._d)
      setStartDate1(moment().subtract(200, "days").startOf('day')._d) //124
      setEndDate(moment().subtract(1, "days").endOf('day')._d)
      setdynamicInterval("minute")
    } else {
      setType("tml_cv_ev_stg_staging_can_bus");
      setStartDate1(new Date("Tue Jul 04 2023 00:00:00 GMT+0530"))
      setStartDate(moment().subtract(7, "days").startOf('day')._d)
      setEndDate(moment().subtract(1, "days").endOf('day')._d)
      setEndDate1(moment().subtract(1, "days").endOf('day')._d)
      setdynamicInterval("second")
    }
    setChangedTypeObj(obj)
    setCountry(obj);
    setLangList([]);
    setFirstOption("")
    setVinNumber('')
  };
  // code copied from cgarging page 

  const reset = (e) => {
    e.preventDefault()
    window.location.reload(true)
  }

  return (
    <>
      <DashboardMain>
        <div className="container-fluid aisMainDiv">
          <div className="text-end"><button type="button" id="filterIcon" className="btn btn-outline-primary material-icons ev_filter_icon" onClick={filterHideShow}>filter_alt</button></div>
          <div className="aisFilterDiv pt-2 mt-1" id="filterSearch" style={{ display: 'none', zIndex: 1 }}>
            <form className="row g-3 mt-2 aisFilterForm justify-content-center">
              <div className="row">
                <div className="col-lg-2 col-md-6 col-sm-12">
                  <div className="mb-3">
                    <label htmlFor="exampleFormControlInput2" className="form-label">Type</label>
                    <Select
                      placeholder="Select"
                      value={country}
                      options={dataJson}
                      onChange={handleCountryChange}
                      getOptionLabel={x => x.region}
                      getOptionValue={x => x.country_code}
                    />
                    <p className="text-danger text-left" style={{ fontSize: "12px" }}><b>{emptyTypeError}</b></p>
                  </div>
                </div>

                <div className="col-lg-2 col-md-6 col-sm-12">
                  <div className="mb-3">
                    <label htmlFor="exampleFormControlInput1" className="form-label">Start Date &amp; Time</label>
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      timeInputLabel="Time:"
                      dateFormat="dd-MM-yyyy h:mm aa"
                      timeFormat="HH:mm"
                      showTimeInput
                      minDate={startDate1}
                      maxDate={endDate1}
                    />
                  </div>
                </div>
                <div className="col-lg-2 col-md-6 col-sm-12">
                  <div className="mb-3">
                    <label htmlFor="exampleFormControlInput2" className="form-label">End Date &amp; Time</label>
                    <DatePicker
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                      timeInputLabel="Time:"
                      dateFormat="dd-MM-yyyy h:mm aa"
                      timeFormat="HH:mm"
                      showTimeInput
                      minDate={startDate1}
                      maxDate={endDate1}
                    />
                    <p className="text-danger text-left forDayError" style={{ fontSize: "12px" }}><b>{daysGreterSeven}</b></p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <label htmlFor="exampleFormControlInput2" className="form-label">Vin No / Chassis No</label>
                  <input autoComplete="off" className="top-filterARAI filter-col" placeholder="Vin No / Chassis No" id="vin_num" name="vin_num" onChange={vinNumChanged} value={vinNumber} />
                  <p className="text-danger text-left" style={{ fontSize: "12px" }}><b>{emptyMultiVinError}</b></p>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <div className="mb-3">
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="mt-3">
                          <label className="form-label" />
                          <button className="form-control btn btn-primary" type="submit" onClick={filterChanged}>Search</button>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="mt-3">
                          <label className="form-label" />
                          <button type="submit" onClick={reset} className="form-control btn btn-secondary">Reset</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div className="container-fluid">
          <section className="Charts">
            <div className="row">
              <ChartFirst langList={langList} filterObject={filterObject} dynamicInterval={dynamicInterval} />
              <ChartSecond langList={langList} filterObject={filterObject} dynamicInterval={dynamicInterval} />
            </div>
          </section>
        </div>

      </DashboardMain>
    </>
  );
}
